import apiService from '@/services/apiService';

const actions = {
  getPointOfSales({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/tools/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postTools({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/tools', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postActivation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`paxelian-club/tools/activation/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putTools({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelian-club/tools/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deletePointOfSales({ commit }, id) {
    return new Promise((resolve, reject) => {
      apiService.delete(`paxelian-club/tools/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

};

export default actions;